export const PAGE_SIZE = 10
export const ONE = 1
export const ANTD_ACENDING = 'ascend'
export const ANTD_DESCENDING = 'descend'
export const ACENDING = 'ASC'
export const DESCENDING = 'DESC'
export const SCROLL = 'max-content'
export const SCROLL_DOWN = 'max-content'

export const ARTICLE = 'ARTICLE'
export const CATEGORY_COLUMNS = 'CATEGORY_COLUMNS'
export const TAG_COLUMNS = 'TAG_COLUMNS'
export const SITE_COLUMNS = 'SITE_COLUMNS'
export const DATASET = 'DATASET'
export const DISCOVERY = 'DISCOVERY'

export const INSIGHT = 'INSIGHT'
export const USER_COLUMNS = 'USER_COLUMNS'
export const WEBPAGE = 'WEBPAGE'
export const ATTACHMENTS = 'ATTACHMENTS'
export const ORDER_CATEGORIES = 'ORDER_CATEGORIES'

const STATUS = { key: 'status', name: 'Status', show: true }
const TITLE = { key: 'title', name: 'Title', show: true }
const SHORT_DESCRIPTION = { key: 'short_description', name: 'Introduction', show: true }
const ORGANISATIONS = { key: 'organisations', name: 'View Permissions', show: true }
const USER_TYPE = { key: 'user_type', name: 'User Type', show: true }
const USER_TYPES = { key: 'user_types', name: 'User Type Permissions', show: true }
const CATEGORY = { key: 'category', name: 'Category', show: true }
const UPDATE_FREQUENCY = { key: 'update_frequency', name: 'Updated', show: true }
const CREATED = { key: 'created', name: 'Created', show: true }
const MODIFIED = { key: 'modified', name: 'Modified', show: true }

const NAME = { key: 'name', name: 'Name', show: true }
const INTRODUCTION = { key: 'introduction', name: 'Introduction', show: true }

const LOGIN_TYPE = { key: 'login_type', name: 'Login Type', show: true }
const FIRST_NAME = { key: 'first_name', name: 'First Name', show: true }
const LAST_NAME = { key: 'last_name', name: 'Last Name', show: true }
const EMAIL = { key: 'email', name: 'Email', show: true }

const SITE_NAME = { key: 'site_name', name: 'Site Name', show: true }
const SITE_LOGO = { key: 'site_logo', name: 'Site Logo', show: true }
const SITE_FAVICON = { key: 'site_favicon', name: 'Site Favicon', show: true }
const SITE_COLOUR = { key: 'site_colour', name: 'Primary Colour', show: true }

const DOCUMENT = { key: 'file_name', name: 'Document', show: true }
const FILE_TYPE = { key: 'file_extension', name: 'File type', show: true }
const FILE_SIZE = { key: 'file_size', name: 'File size', show: true }

export const COLUMNS = {
  ARTICLE: [
    STATUS,
    TITLE,
    SHORT_DESCRIPTION,
    USER_TYPES,
    ORGANISATIONS,
    CATEGORY,
    UPDATE_FREQUENCY,
    CREATED,
    MODIFIED
  ],
  ATTACHMENTS: [
    DOCUMENT,
    FILE_TYPE,
    CREATED,
    USER_TYPES,
    FILE_SIZE
  ],
  CATEGORY_COLUMNS: [
    NAME,
    INTRODUCTION,
    CREATED
  ],
  DATASET: [
    STATUS,
    TITLE,
    SHORT_DESCRIPTION,
    USER_TYPES,
    ORGANISATIONS,
    CATEGORY,
    UPDATE_FREQUENCY,
    CREATED,
    MODIFIED
  ],
  DISCOVERY: [
    STATUS,
    TITLE,
    SHORT_DESCRIPTION,
    USER_TYPES,
    ORGANISATIONS,
    CATEGORY,
    UPDATE_FREQUENCY,
    CREATED,
    MODIFIED
  ],
  INSIGHT: [
    STATUS,
    TITLE,
    SHORT_DESCRIPTION,
    USER_TYPES,
    ORGANISATIONS,
    CATEGORY,
    UPDATE_FREQUENCY,
    CREATED,
    MODIFIED
  ],
  ORDER_CATEGORIES: [
    NAME
  ],
  SITE_COLUMNS: [
    SITE_NAME,
    SITE_LOGO,
    SITE_FAVICON,
    SITE_COLOUR,
    CREATED,
    MODIFIED
  ],
  TAG_COLUMNS: [
    NAME
  ],
  USER_COLUMNS: [
    STATUS,
    LOGIN_TYPE,
    FIRST_NAME,
    LAST_NAME,
    EMAIL,
    USER_TYPE,
    ORGANISATIONS,
    CREATED
  ],
  WEBPAGE: [
    STATUS,
    TITLE,
    SHORT_DESCRIPTION,
    USER_TYPES,
    ORGANISATIONS,
    CATEGORY,
    UPDATE_FREQUENCY,
    CREATED,
    MODIFIED
  ]
}
